import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { motion } from 'framer-motion';

export const CookieBanner: React.FC = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const cookieConsent = Cookies.get('cookieAccepted');
        if (!cookieConsent) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        Cookies.set('cookieAccepted', 'true', { expires: 365 });
        setShowBanner(false);
    };

    if (!showBanner) return null; // Don't render anything if accepted

    return (
        <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{
                position: "fixed",
                bottom: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "white",
                color: "#101A2C",
                padding: "16px 24px",
                borderRadius: "30px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                zIndex: 9999,
                fontSize: "1rem",
            }}
        >
            <span>Ce site utilise des cookies pour améliorer votre expérience.</span>
            <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                onClick={handleAccept}
                style={{
                    backgroundColor: "#36a9e0",
                    color: "white",
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "20px",
                    cursor: "pointer",
                    fontWeight: 600,
                    fontSize: "1rem",
                    transition: "background-color 0.3s ease",
                }}
            >
                Accepter
            </motion.button>
        </motion.div>
    );
};

export default CookieBanner;